import { React, useContext, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SessionProvider, SessionContext } from "./context/SessionContext";
import { ProfileProvider, ProfileContext } from "./context/ProfileContext";
import { DeviceProvider, DeviceContext } from "./context/DeviceContext";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "react-loading-skeleton/dist/skeleton.css";
import "remixicon/fonts/remixicon.css";
import "./index.css";

import ScrollToTop from "./components/ScrollToTop";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Logs from "./pages/Logs";
import Announcements from "./pages/Announcements";
import Announcement from "./pages/Announcement";
import Students from "./pages/Students";
import Personnel from "./pages/Personnel";
import Roles from "./pages/Roles";
import Users from "./pages/Users";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import Logo from "./components/Logo";
import Student from "./pages/Student";
import Scanner from "./pages/Scanner";
import PersonnelInfo from "./pages/PersonnelInfo";
import User from "./pages/User";
import Role from "./pages/Role";
import Devices from "./pages/Devices";
import Device from "./pages/Device";
import DeviceSetup from "./pages/DeviceSetup";

const root = createRoot(document.getElementById("root"));

export default function App() {
	const [session] = useContext(SessionContext);
	const [deviceSession] = useContext(DeviceContext);
	const [, setProfile] = useContext(ProfileContext);

	const getProfile = async () => {
		const requestOptions = {
			method: "GET",
			headers: { "X-Auth-Token": session },
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/users/me`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			console.log("Something went wrong.");
		} else {
			setProfile(data.user);
		}
	};

	useEffect(() => {
		if (session) {
			getProfile();
		}
	}, [session]);

	return (
		<BrowserRouter>
			<ScrollToTop />
			<Routes>
				<Route
					path="/*"
					element={!session ? <Navigate to="/login" /> : <Layout />}
				>
					<Route index element={<Home />} />
					<Route path="logs" element={<Logs />} />
					<Route path="announcements" element={<Announcements />} />
					<Route path="announcements/:id" element={<Announcement />} />
					<Route path="students" element={<Students />} />
					<Route path="students/:id" element={<Student />} />
					<Route path="personnel" element={<Personnel />} />
					<Route path="personnel/:id" element={<PersonnelInfo />} />
					<Route path="users" element={<Users />} />
					<Route path="users/:id" element={<User />} />
					<Route path="roles" element={<Roles />} />
					<Route path="roles/:id" element={<Role />} />
					<Route path="devices" element={<Devices />} />
					<Route path="devices/:id" element={<Device />} />
				</Route>
				<Route
					path="login"
					element={!session ? <Login /> : <Navigate to="/" />}
				/>
				<Route path="logo" element={<Logo />} />
				<Route path="logout" element={<Logout />} />
				<Route path="device-setup" element={<DeviceSetup />} />
				<Route
					path="scanner"
					element={
						!deviceSession ? <Navigate to="/device-setup" /> : <Scanner />
					}
				/>
			</Routes>
		</BrowserRouter>
	);
}

root.render(
	<SessionProvider>
		<ProfileProvider>
			<DeviceProvider>
				<App />
			</DeviceProvider>
		</ProfileProvider>
	</SessionProvider>
);
